export const positionOptions = [
  { value: "", label: "Select a type" },
  { value: "full", label: "Full Time" },
  { value: "part", label: "Part Time" },
  { value: "internship", label: "Internship" },
  { value: "seasonal", label: "Temporary/Seasonal" },
];
